import React, { useEffect, useState } from 'react'

import TaskHeaderErrors from 'components/TaskHeaderErrors/TaskHeaderErrors'

import { API_URL, fetchOptions, parseJSONContent } from 'store/fetchUtils'
import { translateErrorMessage } from 'hooks/useSubmitTask'

import styles from './../Dialog.module.sass'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import useSession from 'hooks/useSession'

import { ippForecastSchema } from './IppForecastSchema'
import { FormProvider, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import HFTextInput from 'components/HFInputs/HFTextInput'
import { flatHookFormErrors } from 'controllers/TaskManager/controllers/utils'
import { useReload } from 'store'

const IppForecastDialog = (props) => {
	const { i18n, pushNotification } = useGlobal()
	const { logout } = useSession()
	const { className, data, dismiss, resolve } = props
	const [submitting, setSubmitting] = useState(false)
	const [error, setError] = useState(null)
	const reload = useReload()

	const methods = useForm({
		mode: 'onSubmit',
		resolver: zodResolver(ippForecastSchema),
		shouldUnregister: true,
	})
	const { handleSubmit, formState } = methods

	const onSubmit = (formData) => {
		if (submitting) {
			return
		}

		const endpoint = `${API_URL}/api/clinical_processes/${data?.processId}/ipp_forecast`

		setError(null)
		setSubmitting('submitting')

		return fetch(
			endpoint,
			fetchOptions({
				method: 'POST',
				body: formData,
			})
		)
			.then((r) => parseJSONContent(r))
			.then(() => {
				resolve && resolve()
				reload([`/clinical_processes/${data?.processId}/tasks`])
				pushNotification(
					undefined,
					'success',
					i18n`Manual IPP requested successfully!`
				)
			})
			.catch((e) => {
				if (e.status === '401' || e.status === 401) {
					logout()
				}

				const errorMessage = translateErrorMessage(e, i18n)

				setSubmitting(false)
				setError([errorMessage])
			})
	}

	useEffect(() => {
		const flattenErrors = flatHookFormErrors(formState.errors)

		if (flattenErrors) {
			const errorMessages = Object.keys(flattenErrors).map((errorKey) => {
				const errorMessage = flattenErrors[errorKey]
				const splittedErrorKey = errorKey.split('.')
				const field = splittedErrorKey[splittedErrorKey.length - 2]

				return `${i18n.translate(field)}: ${i18n.translate(
					errorMessage
				)}`
			})
			setError(errorMessages)
		}
	}, [formState.errors, i18n])

	return (
		<>
			<TaskHeaderErrors errors={error ?? []} />
			<FormProvider {...methods}>
				<form
					id={'form_ipp_forecast'}
					onSubmit={handleSubmit(onSubmit)}
					className={`${styles['root'] || ''} ${className || ''}`}
					disabled={submitting}
				>
					<fieldset>
						<small className={styles['dialog-title']}>
							<strong>{i18n`Enter IPP forecast request`}</strong>
						</small>
						<HFTextInput
							placeholder={i18n`Reason`}
							name='reason'
							multiline
							noResize
							rows='3'
							required
						/>
					</fieldset>
				</form>
			</FormProvider>
			<menu>
				<ActionButton type='button' secondary onClick={dismiss}>
					<small>
						<strong>{i18n`Cancel`}</strong>
					</small>
				</ActionButton>
				<ActionButton form={`form_ipp_forecast`} primary>
					<small>
						<strong>
							{submitting ? i18n`Submitting` : i18n`Send`}
						</strong>
					</small>
				</ActionButton>
			</menu>
		</>
	)
}

export default IppForecastDialog
